import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { ExamLearnset } from 'src/app/models/exam-learnset.model';
import { Learnset } from 'src/app/models/learnset.model';

@Component({
  selector: 'app-learnset-selection-list',
  templateUrl: './learnset-selection-list.component.html',
  styleUrls: ['./learnset-selection-list.component.scss'],
  standalone: false
})
export class LearnsetSelectionList {

  @Input() courseId?: number;
  @Input() learnsets?: Learnset[] = [];

  examLearnsets?: ExamLearnset[] = [];
  @Output() examLearnsetsChange: EventEmitter<ExamLearnset[]> = new EventEmitter<ExamLearnset[]>();

  @Output() totalCountChange: EventEmitter<number> = new EventEmitter<number>();

  isLoading: boolean = false;
  totalCount: number = 0;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['learnsets'] && this.learnsets) {
      this.examLearnsets = this.learnsets.map(learnset => new ExamLearnset(learnset.id!, learnset.name, true, Math.floor(10 / this.learnsets!.length)));
      this.examLearnsetsChange.emit(this.examLearnsets);
      this.updateTotalCount();
    }
  }

  selectionChanged() {
    this.updateTotalCount();
    this.examLearnsetsChange.emit(this.examLearnsets);
  }

  updateTotalCount() {
    this.totalCount = this.examLearnsets!.reduce((sum, learnset) => learnset.isSelected ? sum + learnset.questionsCount : sum, 0);
    this.totalCountChange.emit(this.totalCount);
  }
}
